module.exports = "<app-tab-view [comments]=\"comments$|async\" [history]=\"history$|async\"></app-tab-view>"